
interface UniversalPaginationProps<T> {
  currentPage: number;
  itemsPerPage: number;
  paginate: (pageNumber: number) => void;
  items: T[]; 
}

function UniversalPagination<T>({ currentPage, itemsPerPage, paginate, items }: UniversalPaginationProps<T>) {
  const totalPages = Math.ceil(items.length / itemsPerPage);

  const getVisiblePages = () => {
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  };

  return (
    <div className="pagination">
      <button
        onClick={() => paginate(currentPage - 1)}
        disabled={currentPage === 1}
      >
        Назад
      </button>

      {currentPage > 3 && (
        <>
          <button onClick={() => paginate(1)}>1</button>
          {currentPage > 4 && <span className="dots">...</span>}
        </>
      )}

      {getVisiblePages().map((page) => (
        <button
          key={page}
          onClick={() => paginate(page)}
          className={currentPage === page ? "active" : ""}
        >
          {page}
        </button>
      ))}

      {currentPage < totalPages - 2 && (
        <>
          {currentPage < totalPages - 3 && <span className="dots">...</span>}
          <button onClick={() => paginate(totalPages)}>{totalPages}</button>
        </>
      )}

      <button
        onClick={() => paginate(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        Вперед
      </button>
    </div>
  );
}

export default UniversalPagination; 